import L from 'leaflet';
import OSRMv1 from 'leaflet-routing-machine';
import './control.geocoder.nomenatim.js';
import './leaflet.nearestlayer.js';
import Swiper from 'swiper';

function isDesktop() {
    return window.innerWidth >= 700;
}

function isEmbedded() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function fetchJSON(url, callback, context) {
    var request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function() {
        var data = JSON.parse(request.responseText);
        callback.call(context, data);
    };
    request.send();
}

L.DomEvent.on(L.DomUtil.get('popup-close-button'), {
    'click': function(e) {
        L.DomUtil.removeClass(document.body, 'popup-open');
    }
});

function showPopup(text) {
    L.DomUtil.addClass(document.body, 'popup-open');
    L.DomUtil.get('popup-context').textContent = text;
}

var initial = {
    position: [53.21695,6.5597069],
    zoom: 16
};

var OSRM = L.Routing.OSRMv1.extend({
    initialize: function(options) {
        L.Routing.OSRMv1.prototype.initialize.call(this, options);
        this._resetCache(null);
    },
    buildRouteUrl: function(waypoints, options) {
        return L.Routing.OSRMv1.prototype.buildRouteUrl.call(this, waypoints, options).replace('&alternatives=true', '&alternatives=false');
    },
    route: function(waypoints, callback, context, options) {
        this._resetCache(waypoints[0]);
        var key = this._routeHash(waypoints);

        if (!(this._cache[key])) {
            this._cache[key] = new Promise(L.Util.bind(function(resolve, reject) {
                L.Routing.OSRMv1.prototype.route.call(this, waypoints, function(status, routes) {
                    resolve([status, routes]);
                }, null, options);
            }, this));
        }

        this._cache[key].then(function(args) {
            callback.apply(context, args);
        });
    },
    _routeHash: function(waypoints) {
        return waypoints.map(function(waypoint) {
            return waypoint.latLng.toString();
        }).join(";");
    },
    _resetCache: function(startPosition) {
        if (!this._cacheStartPosition || !startPosition || !this._cacheStartPosition.equals(startPosition.latLng)) {
            this._cache= {};
            this._cacheStartPosition = startPosition ? startPosition.latLng : null;
        }
    }
});

var Viewer = L.Evented.extend({
    initialize: function() {
        this.map = L.map('map', {
            zoomControl: false,
            zoomSnap: 0,
            minZoom: 12
        });

        this.map.on('load', function() {
            L.DomUtil.removeClass(document.body, 'loading');
        });

        this.map.setView(initial.position, initial.zoom);

        this.drawer = L.DomUtil.get('drawer');

        L.tileLayer('//service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/standaard/EPSG:3857/{z}/{x}/{y}.png', {
            attribution: 'Kaartgegevens © <a href="http://kadaster.nl">Kadaster</a>, <a href="https://www.openstreetmap.org">OSM</a>'
        }).addTo(this.map);

        this.routeControl = L.Routing.control({
            waypoints: [],
            language: 'nl',
            router: new OSRM({
                serviceUrl: '/osrm/route/v1',
                profile: 'foot',
                language: 'nl'
            }),
            summaryTemplate: '<h2>{name}</h2><h3 class="duration bicycle">{distance}, {time}</h3>',
            draggableWaypoints: false, // (we implement this ourselves)
            addWaypoints: false,
            routeWhileDragging: false,
            reverseWaypoints: true,
            showAlternatives: false,
            fitSelectedRoutes: false,
            createMarker: function() {
                return false;
            }
        }).addTo(this.map);

        L.Routing.errorControl(this.routeControl).addTo(this.map);

        // Move the route plan to the navigation drawer
        L.DomUtil.get('route').appendChild(this.routeControl._container);

        this.on('destinationchanged', this.updateRoute, this);

        // Current (my) location marker. You can move it :)
        this.location = L.marker(null, {
            draggable: true,
            zIndexOffset: 10000
        });

        this.location.on('moveend', function() {
            this.fire('locationchanged', {location: this.location, context: {}});
        }, this);

        this.destination = null;

        // Only filter on opening hours between 7:00 and 21:00
        var from = new Date();
        from.setHours(7);
        from.setMinutes(0);

        var till = new Date();
        till.setHours(21);
        till.setMinutes(0);

        var now = new Date();

        this.filter = {
            onlyOpen: now > from && now < till,
            onlyAccessible: false
        };

        var filters = {
            'filter-all': {
                onlyOpen: false,
                onlyAccessible: false
            },
            'filter-open': {
                onlyOpen: true,
                onlyAccessible: false
            },
            'filter-accessible': {
                onlyOpen: now > from && now < till,
                onlyAccessible: true
            }
        };

        Object.entries(filters).forEach(function(option) {
            var checkbox = L.DomUtil.get(option[0]);

            // Mark this option as selected if this reflects the current state of filter
            checkbox.checked = Object.entries(option[1]).every(function(setting) {
                return this.filter[setting[0]] == setting[1];
            }, this);

            // On change, apply the settings to the viewer
            L.DomEvent.addListener(checkbox, 'change', function(e) {
                if (checkbox.checked) {
                    Object.entries(option[1]).forEach(function(setting) {
                        if (setting[0] == 'id') return;
                        this.filter[setting[0]] = setting[1]
                    }, this);
                    this.fire('filterchanged', this.filter);
                }
            }, this);
        }, this);
    },

    setLocationLatLng: function(latlng, context) {
        this.location.setLatLng(latlng);
        if (!this.location._map)
            this.location.addTo(this.map);

        this.fire('locationchanged', {location: this.location, context: context});
    },

    setDestination: function(layer, context) {
        if (layer === undefined)
            throw new Error('layer is undefined');

        this.destination = layer;
        this.fire('destinationchanged', {destination: this.destination, context: context});
    },

    updateRoute: function(e) {
        if (this.location.getLatLng() && this.destination) {
            this.routeControl.setWaypoints([
                this.location.getLatLng(),
                this.destination.getLatLng()
            ]);
        }
    }
});

var LocationWidget = L.Evented.extend({
    initialize: function() {
        this._addressField = L.DomUtil.get('location-address-field');

        this._suggestionsList = L.DomUtil.get('location-suggestions');

        this.geocoder = new L.Control.Geocoder.Nominatim({
            geocodingQueryParams: {
                viewbox: "2.1862792968750004,50.324422739309384,8.217773437500002,54.13669645687002",
                bounded: 1
            }
        });

        this._suggestions = null;

        // Listen to clicks on the 'go!' button
        L.DomEvent.addListener(
            L.DomUtil.get('location-find-address'),
            'click', function(e) {
                this.lookup(this._addressField.value);
            }, this);

        // Listen to clicks on the clear button
        L.DomEvent.addListener(
            L.DomUtil.get('location-clear-address'),
            'click', function(e) {
                clearTimeout(this._lookupDelay);
                this._processSuggestions([]);
                this._addressField.value = '';
                this._addressField.focus();
            }, this);

        // Listen for changes in the address field to trigger suggestions
        L.DomEvent.addListener(
            this._addressField,
            'keyup', function(e) {
                if (this._addressField.value.length > 3)
                    this.lookup(this._addressField.value, 350);
            }, this);

        L.DomEvent.addListener(
            this._addressField,
            'keydown', function(e) {
                clearTimeout(this._lookupDelay);

                switch (e.keyCode) {
                    case 13:
                        this.lookup(this._addressField.value, 0, this._acceptSuggestions, this);
                        break;

                    case 38:
                        this._suggestionsList.lastElementChild.focus();
                        e.preventDefault();
                        break;

                    case 40:
                        this._suggestionsList.firstElementChild.focus();
                        e.preventDefault();
                        break;
                }
            }, this);

        // Listen for navigation keys in the suggestion list
        L.DomEvent.addListener(
            this._suggestionsList,
            'keydown', function(e) {
                if (!document.activeElement || document.activeElement.parentNode != this._suggestionsList)
                    return;

                switch (e.keyCode) {
                    case 13: // enter
                        this._locationFound(document.activeElement.getAttribute('data-idx'));
                        e.preventDefault();
                        break;

                    case 38: // up
                        if (document.activeElement.previousElementSibling)
                            document.activeElement.previousElementSibling.focus();
                        else
                            this._addressField.focus();
                        e.preventDefault();
                        break;

                    case 40: // down
                        if (document.activeElement.nextElementSibling)
                            document.activeElement.nextElementSibling.focus();
                        else
                            this._addressField.focus();
                        e.preventDefault();
                        break;
                }
            }, this);

        // Listen for clicks in the suggestion list
        L.DomEvent.addListener(
            this._suggestionsList,
            'click', function(e) {
                var item = e.target;

                // Find the <li>
                while (item.parentNode != this._suggestionsList) {
                    if (item.parentNode)
                        item = item.parentNode;
                    else
                        return;
                }

                this._locationFound(item.getAttribute('data-idx'));
                e.preventDefault();
            }, this);

        L.DomEvent.addListener(
            L.DomUtil.get('location-control'),
            'focusin', function(e) {
                if (!e.relatedTarget || !this.contains(e.relatedTarget))
                    L.DomUtil.addClass(L.DomUtil.get('location-control'), 'focussed');
            });

        L.DomEvent.addListener(
            L.DomUtil.get('location-control'),
            'focusout', function(e) {
                if (!e.relatedTarget || !this.contains(e.relatedTarget))
                    L.DomUtil.removeClass(L.DomUtil.get('location-control'), 'focussed');
            });
    },

    focus: function() {
        this._addressField.focus();
    },

    lookup: function(value, delay, callback, context) {
        clearTimeout(this._lookupDelay);

        this._lookupDelay = setTimeout((function() {
            this._query(value, callback, context);
        }).bind(this), delay || 10);
    },

    _query: function(value, callback, context) {
        // this.geocoder.options.geocodingQueryParams = {
        //     viewbox: this._map.getBounds().toBBoxString(),
        // };
        if (!callback) {
            callback = this._processSuggestions;
            context = this;
        }

        this.geocoder.geocode(value, callback, context);
    },

    _processSuggestions: function(results) {
        // Clear the list
        this._suggestionsList.innerHTML = '';

        this._suggestions = results;

        results.forEach(function(result, idx) {
            var li = L.DomUtil.create('li', 'location-suggestion', this._suggestionsList);
            li.textContent = result.name;
            li.tabIndex = 0;
            li.setAttribute('data-idx', idx);
        }, this);
    },

    _acceptSuggestions: function(results) {
        // Clear the list
        this._suggestionsList.innerHTML = '';

        this._suggestions = results;

        if (results.length > 0)
            this._locationFound(0);
    },

    _locationFound: function(idx) {
        if (document.activeElement && L.DomUtil.get('location-control').contains(document.activeElement)) {
            viewer.map._container.focus();
        }

        this.fire('locationfound', {
            location: this._suggestions[idx],
            latlng: this._suggestions[idx].center
        });
    }
});

L.TopoJSON = L.GeoJSON.extend({
    addData: function(jsonData) {
        if (jsonData.type === "Topology") {
            for (var key in jsonData.objects) {
                var geojson = topojson.feature(jsonData, jsonData.objects[key]);
                L.GeoJSON.prototype.addData.call(this, geojson);
            }
        }
        else {
            L.GeoJSON.prototype.addData.call(this, jsonData);
        }
    }
});

L.topoJSON = function(data, options) {
    return new L.TopoJSON(data, options);
};

var viewer = new Viewer();

var locationWidget = new LocationWidget();

locationWidget.on('locationfound', function(e) {
    viewer.setLocationLatLng(e.latlng);
});

function stemlokaalClicked(e) {
    viewer.setDestination(e.target);
}

function isClosed(feature) {
    var now = new Date();

    // Accepteer ook stembureaus die over een half uur open gaan
    var soon = new Date();
    soon.setMinutes(now.getMinutes() + 30);

    try {
        // matches "9:00 - 12:00; 13:00 - 15:00; 17:00 - 19:30"
        var ranges = feature.properties.openingstijden.split(/;\s*/);
        return !ranges.some(function(range) {
            // matches "07:30 - 21:00"
            var match = range.match(/(\d\d?)[:\.](\d\d)\s*-\s*(\d\d?)[:\.](\d\d)/);

            var from = new Date();
            from.setHours(parseInt(match[1], 10));
            from.setMinutes(parseInt(match[2], 10));

            var till = new Date();
            till.setHours(parseInt(match[3], 10));
            till.setMinutes(parseInt(match[4], 10));

            return soon > from && now < till;
        });
    } catch (e) {
        console.error('Could not parse openingstijden "%s": %s', feature.properties.openingstijden, e);
        return null;
    }
}

function isAccessible(feature) {
    return feature.properties.toegankelijk;
}

function isMobile(feature) {
    return /(.*mobiele? stem.*)|Rode Stembus/i.test(feature.properties.naam);
}

function isFiltered(feature) {
    if (viewer.filter.onlyOpen && isClosed(feature) === true)
        return true;

    if (viewer.filter.onlyAccessible && !isAccessible(feature))
        return true;

    return false;
}

var icons = {
    'default': L.icon({
        iconUrl: 'stemlokaal-icon.png',
        iconRetinaUrl: 'stemlokaal-icon-2x.png',
        shadowUrl: 'stemlokaal-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    }),
    'accessible': L.icon({
        iconUrl: 'stemlokaal-toegankelijk-icon-2x.png',
        iconRetinaUrl: 'stemlokaal-toegankelijk-icon-2x.png',
        shadowUrl: 'stemlokaal-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    }),
    'mobile':  L.icon({
        iconUrl: 'stemlokaal-tijdelijk-icon-2x.png',
        iconRetinaUrl: 'stemlokaal-tijdelijk-icon-2x.png',
        shadowUrl: 'stemlokaal-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    }),
    'filtered': L.icon({
        iconUrl: 'stemlokaal-filtered-icon-2x.png',
        iconRetinaUrl: 'stemlokaal-filtered-icon-2x.png',
        shadowUrl: 'stemlokaal-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    })
}

var StemlokaalMarker = L.Marker.extend({
    options: {
        icon: icons.default
    }
});

var stemlokaalData = new L.NearestLayerMixin(null, {
    url: '/stembureaus/features',
    pointToLayer: function(geoJsonPoint, latlng) {
        var marker = new StemlokaalMarker(latlng, {
            title: geoJsonPoint.properties.naam,
            isMobile: isMobile(geoJsonPoint),
            isAccessible: isAccessible(geoJsonPoint)
        });

        var setIcon = function() {
            if (marker.options.isMobile)
                marker.setIcon(icons.mobile);
            else if (marker.options.isAccessible)
                marker.setIcon(icons.accessible);
            else
                marker.setIcon(icons.default);

            marker.setOpacity(isFiltered(geoJsonPoint) ? 0.5 : 1.0);
        };

        setIcon();

        marker.on('click', stemlokaalClicked);
        viewer.on('filterchanged', setIcon);

        return marker;
    }
}).addTo(viewer.map);

var gemeenteData = new Promise(function(resolve, reject) {
    fetchJSON('gemeentes.topojson', function(data) {
        resolve(L.topoJSON(data));
    });
});

var destinations = [];

// Show the gemeente bounds on the map
// gemeenteData.then((f) => f.addTo(viewer.map));

var template = L.DomUtil.get('nearest-location-template');
template.parentNode.removeChild(template); // detach!

var swiper = new Swiper('#nearest', {
    speed: 400,
    spaceBetween: 40,
    direction: 'horizontal',
    loop: false,
    pagination: '.swiper-pagination',
    paginationClickable: true,
    onSlideChangeStart: function(swiper) {
        // Because swiper.setSlide also causes this event handler to be
        // called:
        if (swiper._ignoreEvent)
            return;

        swiper._active = true;

        // Set the current destination
        viewer.setDestination(destinations[swiper.activeIndex]);

        // Prefetch the route to the next one
        if (swiper.activeIndex + 1 < destinations.length)
            viewer.routeControl.getRouter().route([
                {latLng: viewer.location.getLatLng()},
                {latLng: destinations[swiper.activeIndex + 1].getLatLng()}
            ], function() {});
        swiper._active = false;
    },
    paginationBulletRender: function (swiper, index, className) {
        try {
            var naam = destinations[index].feature.properties.naam;
        } catch (e) {
            var naam = '';
        }

        return '<span class="' + className + '" title="' + naam.replace("'", "&quot;") + '"></span>';
    }
});

function fitFontSize(element, width, min, max, font) {
    var font = L.extend({
        style: 'normal',
        variant: 'normal',
        weight: 'normal',
        family: 'sans-serif'
    }, font);

    var size = 16;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.font = [font.style, font.variant, font.weight, size + 'px', font.family].join(' ');
    var textWidth = context.measureText(element.textContent).width;
    var textSize = Math.max(Math.min(size / textWidth * width, max), min);
    element.style.fontSize = Math.round(textSize * 100) / 100 + 'px';
}

function fillTemplate(root, data) {
    var nodes = root.getElementsByTagName('*');
    for (var i = 0; i < nodes.length; ++i) {
        try {
            if (nodes[i].hasAttribute('data-property')) {
                if (!(nodes[i].getAttribute('data-property') in data))
                    throw Error('data has no property ' + nodes[i].getAttribute('data-property'));
                nodes[i].textContent = data[nodes[i].getAttribute('data-property')];
            }

            if (nodes[i].hasAttribute('data-class')) {
                var fun = new Function('data', 'return ' + nodes[i].getAttribute('data-class'));
                var classNames = fun(data);
                var list = [];

                for (var className in classNames)
                    if (classNames[className])
                        list.push(className);

                nodes[i].className = list.join(" ");
            }
        } catch (e) {
            console.error('Could not fill in template node:', node, e);
        }
    }
}

function pointInRing(point, vs)
{
    var x = point[0], y = point[1];

    var inside = false;
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0], yi = vs[i][1];
        var xj = vs[j][0], yj = vs[j][1];

        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }

    return inside;
}

function pointInPolygon(point, polygon)
{
    // Test if it is inside the polygon
    if (!pointInRing(point, polygon[0]))
        return false;

    // Test if it is inside a hole
    for (var i = 1; i < polygon.length; ++i)
        if (pointInRing(point, polygon[i]))
            return false;

    return true;
}

function pointInMultiPolygon(point, multipolygon)
{
    for (var i = 0; i < multipolygon.length; ++i)
        if (pointInPolygon(point, multipolygon[i]))
            return true;

    return false;
}

function findNearest(marker, context) {
    marker.options.gemeentenaam = new Promise(function(resolve, reject) {
        gemeenteData.then(function(gemeentes) {
            var x = marker.getLatLng();
            var p = [x.lng, x.lat];

            for (var layer_id in gemeentes._layers) {
                var layer = gemeentes._layers[layer_id];
                var type = layer.feature.geometry.type;

                if (['Polygon', 'MultiPolygon'].indexOf(type) === -1)
                    continue;

                var coordinates = layer.toGeoJSON().geometry.coordinates;

                // normalize to MultiPolygon
                if (type == 'Polygon')
                    coordinates = [coordinates];

                if (pointInMultiPolygon(p, coordinates)) {
                    if ('gemeentena' in layer.feature.properties)
                        return resolve(layer.feature.properties.gemeentena);
                    else
                        throw new Error('Gemeente feature has no property gemeentena');
                }
            }

            throw new Error('Could not determine the municipality for the current location');
        }).catch(function(e) {
            console.error(e);
            resolve(null);  // That is unfortunate, but not a problem
        });
    });

    new Promise(function(resolve, reject) {
        stemlokaalData.nearest(marker.getLatLng(), 10, resolve, function(result) {
            return !isFiltered(result.feature);
        });
    })
        .then(function(nearest) {
            return marker.options.gemeentenaam.then(function(value) {
                nearest.forEach(function(destination) {
                    destination._penalty = value != null && destination.feature.properties.gemeente == value ? 0 : 1;
                });

                return nearest.sort(function(a, b) {
                    return a._penalty - b._penalty;
                });
            });
        })
        .then(function(nearest) {
            return Promise.all(nearest.map(function(destination, index) {
                if (index < 5) {
                    return new Promise(function(resolve, reject) {
                        viewer.routeControl.getRouter().route([
                            {latLng: marker.getLatLng()},
                            {latLng: destination.getLatLng()}
                        ], function(err, routes) {
                            destination._score = Math.min.apply(null, routes.map(function(route) {
                                return route.summary.totalDistance; // also a possibility: totalTime
                            }));
                            resolve(destination);
                        });
                    });
                } else {
                    return new Promise(function(resolve, reject) {
                        destination._score = (index + 1) * 1000000;
                        resolve(destination);
                    });
                }
            }));
        })
        .then(function(nearest) {
            return nearest.sort(function(a, b) {
                if (a._penalty != b._penalty)
                    return a._penalty - b._penalty;
                else
                    return a._score - b._score;
            })
        })
        .then(function(nearest) {
            swiper.removeAllSlides();

            destinations = nearest;

            if (destinations.length === 0) {
                console.warn('0 destinations found');
                return;
            }

            var slides = nearest.map(function(destination) {
                var slide = template.cloneNode(true);
                var data = L.extend(destination.feature.properties, {
                    andereGemeente: destination._penalty == 1 // see above, penalty is assigned based on this
                });
                fillTemplate(slide, data);
                return slide;
            });

            swiper.appendSlide(slides);

            slides.forEach(function(slide) {
                var style = getComputedStyle(slide);
                fitFontSize(
                    slide.getElementsByTagName('h2')[0],
                    swiper.width - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight|| 0) - 24, // 2x padding + the little marker icon
                    12, 24,
                    {weight: 'bold', family:'system-ui, sans-serif'});
            });

            swiper.update(); // fitFontSize changes sizes

            viewer.setDestination(destinations[0], context);
        })
        .catch(function(prut) {
            console.error(prut);
        });
}

L.DomUtil.addClass(document.body, 'locating');
setTimeout(L.Util.bind(viewer.map.locate, viewer.map), 500);

viewer.map.on('locationfound', function(e) {
    viewer.setLocationLatLng(e.latlng);
});

viewer.map.on('locationerror', function(e) {
    L.DomUtil.addClass(document.body, 'locating-manual');
    locationWidget.focus();
});

viewer.on('locationchanged destinationchanged', function(e) {
    if (e.context && e.context.passive) return;

    L.DomUtil.removeClass(document.body, 'locating');
    L.DomUtil.removeClass(document.body, 'locating-manual');
});

viewer.on('destinationchanged', function(e) {
    if (e.context && e.context.passive) return;

    L.DomUtil.removeClass(document.body, 'hide-drawer');
});

viewer.on('locationchanged', function(e) {
    findNearest(e.location);
});

viewer.on('filterchanged', function(e) {
    if (viewer.location && viewer.destination && isFiltered(viewer.destination.feature))
        findNearest(viewer.location);
});

// If the user clicks on a destination, make sure the swiper is showing the correct one
viewer.on('destinationchanged', function(e) {
    // But there is no need if the event originated from the swiper itself
    if (swiper._active)
        return;

    viewer.location.options.gemeentenaam.then(function(gemeentenaam) {
        var index = destinations.findIndex(function(dest) {
            return dest._leaflet_id == e.destination._leaflet_id;
        });

        if (index === -1) {
            if (swiper.slides.length === 0 || swiper.slides.length === 10)
                swiper.appendSlide(template.cloneNode(true));

            var data = L.extend(e.destination.feature.properties, {
                andereGemeente: e.destination.feature.properties.gemeente != gemeentenaam
            });

            index = swiper.slides.length - 1;
            fillTemplate(swiper.slides[index], data);
        }

        swiper._ignoreEvent = true;
        swiper.slideTo(index);
        swiper._ignoreEvent = false;
    })
        .catch(function(e) {
            console.error(e);
        });
});

function mapFitRoute() {
    if (!viewer.destination)
        return;

    var bounds = viewer.routeControl._line.getBounds()
        .extend(viewer.location.getLatLng())
        .extend(viewer.destination.getLatLng());
    viewer.map.fitBounds(bounds, {
        paddingTopLeft: [50, 75],
        paddingBottomRight:
            isDesktop() ? [300, 50] :
                isEmbedded() ? [50, 75] :
                    [50, 20 + swiper.height + 75],
        animate: true
    });
}

// Make sure the location is visible when it changes (i.e. entering it)
viewer.on('locationchanged', function() {
    if (!viewer.map.getBounds().contains(viewer.location.getLatLng()))
        viewer.map.panTo(viewer.location.getLatLng());
});

// Pan & zoom to the route when the route is clicked
viewer.routeControl.on('routeselected', mapFitRoute);

// Pan & zoom to the route when the route is explicitly clicked in the swiper
// Unless we clicked something special
swiper.on('click', function(se, e) {
    var cur = e.target;

    for (; se.clickedSlide != null && cur != se.clickedSlide; cur = cur.parentNode) {
        if (cur.className.indexOf('gemeente') != -1 && cur.className.indexOf('uitzondering') != -1) {
            // We clicked on the red gemeente, show notice
            showPopup('Let op! Dit stembureau ligt in een andere gemeente dan waar je nu bent. Met een normale stempas kan je alleen stemmen in de gemeente waar jij woont.');
            return;
        }

        if (cur.className.indexOf('openingstijden') != -1 && cur.className.indexOf('uitzondering') != -1) {
            showPopup('Let op! Dit stembureau heeft aangepaste openingstijden.');
            return;
        }
    }

    mapFitRoute();
});

function updateDrawerPosition() {
    viewer.drawer.style.position = !isDesktop() && isEmbedded() ? 'relative' : null;
    viewer.drawer.style.top = isDesktop() || isEmbedded() ? null : (document.body.clientHeight - swiper.height - 72) + 'px';
}

function update() {
    L.DomUtil[isEmbedded() ? 'addClass' : 'removeClass'](document.body, 'is-embedded');

    var hideRoute = document.location.hash.match(/\bnoroute\b/);
    L.DomUtil[hideRoute ? 'addClass' : 'removeClass'](document.body, 'hide-route');

    if (!document.body.className.match(/\bhide-drawer\b/))
        updateDrawerPosition();

    mapFitRoute();
}

viewer.on('destinationchanged', updateDrawerPosition);

window.addEventListener('resize', update);

update();
